import React, { useContext } from 'react';
import { SessionContext } from '../../context/SessionContext';
import { ContactUs } from '../../Screens/ContactUs/ContactUs';
import { DealerHome } from '../../Screens/DealerHome/DealerHome';
import { OrderInfoContainer } from '../../Screens/OrderInfoContainer';
import Contract from '../Contract/Contract';
import { Search } from '../Contract/Search';
import { DealerProfile } from '../DealerProfile/DealerProfile';
import ReportsContainer from '../Report/ReportsContainer';
import { ReportContextProvider } from '../Report/ReportsContext';
import ResourceContainer from '../Resources/ResourceContainer';
import PriceTool from '../PriceTool/PriceTool';
import AlertBanner from '../shared/AlertBanner/AlertBanner';

export default function MainTabContent({ session }) {
    const { tabs, activeTab, getCurrentTabAndSubtab, getProfile } = useContext(SessionContext);
    const { tab } = getCurrentTabAndSubtab();
    const profile = getProfile();

    const getTab = () => {
        if (!tab || activeTab === 0) return <DealerHome tabId={5} />;

        switch (tab.tabType) {
            case 'search':
                return (
                    <Search
                        tabId={tab.tabId}
                        state={tab.state}
                    />
                );

            case 'contract':
                return (
                    <Contract
                        title={tab.title}
                        tabId={tab.tabId}
                        contractNumber={tab.contractNumber}
                        client={tab.client}
                        state={tab.state}
                        serviceNumber={tab.serviceNumber}
                        eventData={tab.eventData}
                    />
                );

            case 'serviceRequest':
                return (
                    <Contract
                        title={tab.title}
                        tabId={tab.tabId}
                        contractNumber={tab.contractNumber}
                        serviceNumber={tab.serviceNumber}
                        client={tab.client}
                        state={tab.state}
                        eventData={tab.eventData}
                    />
                );

            case 'claimOverview':
                return (
                    <Contract
                        title={tab.title}
                        tabId={tab.tabId}
                        contractNumber={tab.contractNumber}
                        claimNumber={tab?.claimNumber}
                        client={tab.client}
                        state={tab.state}
                    />
                );
            case 'reports':
                return (
                    <ReportContextProvider reportType={tab.reportType}>
                        <ReportsContainer />
                    </ReportContextProvider>
                );

            case 'orderinfo':
                return (
                    <OrderInfoContainer
                        title={tab.title}
                        tabId={tab.tabId}
                        state={tab.state}
                    />
                );

            case 'profile':
                return (
                    <DealerProfile
                        title={tab.title}
                        tabId={tab.tabId}
                        activeProfileTab={getCurrentTabAndSubtab().tab?.activeProfileTab}
                        state={tab.state}
                    />
                );

            case 'resources':
                return (
                    <ResourceContainer
                        title={tab.title}
                        tabId={tab.tabId}
                        state={tab.state}
                    />
                );

            case 'contactus':
                return (
                    <ContactUs
                        title={tab.title}
                        tabId={tab.tabId}
                        state={tab.state}
                    />
                );

            case 'pricing':
                return (
                    <PriceTool
                        title={tab.title}
                        tabId={tab.tabId}
                        state={tab.state}
                    />
                );

            default:
                return <>Developer Error. Tab Type not recognized.</>;
        }
    };

    return (
        <div className='container-fluid'>
            <main>
                <div className='mainContainerWrapper'>
                    <div className='tab-content'>
                        {session.alerts.map((alert, key) => (
                            <AlertBanner
                                key={key}
                                content={alert.message}
                                hasClose={alert.hasClose}
                                onClose={() => session.handleCloseAlert(alert.id)}
                                show={key == 0}
                                bannerType={alert.type}
                                linkText={alert.linkText}
                                customClass={tab?.tabType === 'contract' && 'contentClass'}
                                linkClick={() =>
                                    session.handleLinkClick(
                                        alert.linkDestinationTitle,
                                        alert.linkDestination,
                                        alert.linkText,
                                        alert.claimNumber,
                                        profile
                                    )
                                }
                                hasLink={
                                    alert.hasLink
                                    && (typeof session.tabs[session.activeTab - 1] === 'undefined'
                                        || (typeof session.tabs[session.activeTab - 1] !== 'undefined'
                                            && session.tabs[session.activeTab - 1].title !== alert.linkDestinationTitle
                                            && session.tabs[session.activeTab - 1].tabType !== 'serviceRequest'))
                                }
                            />
                        ))}
                        {getTab()}
                    </div>
                </div>
            </main>
        </div>
    );
}
